import { useEffect, useState } from "react";

const useIsScrolled = (threshold = 0) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    let animationFrame: number | null = null;

    const updateScrollState = () => {
      setIsScrolled(window.scrollY > threshold);
      animationFrame = null;
    };

    const handleScroll = () => {
      if (animationFrame === null) {
        animationFrame = window.requestAnimationFrame(updateScrollState);
      }
    };

    updateScrollState();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);

      if (animationFrame !== null) {
        window.cancelAnimationFrame(animationFrame);
      }
    };
  }, [threshold]);

  return isScrolled;
};

export default useIsScrolled;
